module.exports = __webpack_public_path__ + "static/img/net-border-1.906f87f8.png";